import {HttpEvent, HttpHandlerFn, HttpRequest,} from '@angular/common/http';
import {inject} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../service/auth.service';

export function UrlUpdateInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);

  if (request.url.includes('login') ||
    request.url.includes('resetPassword') ||
    request.url.includes('objectstorage') ||
    request.url.includes('/acl/') ||
    request.url.includes('oauth/token') ||
    (request.url.includes('serra') && !request.url.includes('groupReport')) ||
    request.url.includes('json-generator') ||
    request.url.includes('s3') ||
    request.url.includes('camvalive')) {
    return next(request);
  }

  const user = authService.getCurrentUser();
  const headers = request.headers.append('Authorization', user.accessToken);
  const group = JSON.parse(localStorage.getItem('group') ?? '{}');
  let apiUrl = ``;
  if(!request.url.includes('updatePassword') && !request.url.includes('groupReport')
    && !request.url.includes('report/proxy') && !request.url.includes('alertService') && !request.url.includes('pulsevs'))
    apiUrl = `${environment.apiUrl}${group?.id === 24 ? '/' + group.id : ''}/falcon`;

    if(request.url.includes('datagrid') || request.url.includes('external') || request.url.includes('legacy') || request.url.includes('dashboard')) {
      apiUrl = `${environment.apiUrl}`;
    }

    if (request.url.startsWith('http://localhost')) {
    return next(request.clone({ headers }));
    }
    
    let clone = request.clone({
    url: `${apiUrl}${request.url}`,
    headers,
  });

  if (request.url.includes('/regraplaca/import/excel')) {
    const params = request.params.append('email', user.email);
    clone = request.clone({
      url: `${apiUrl}${request.url}`,
      headers,
      params,
    });
  }
  return next(clone);
}
